// The home screen. It is an overlay, not a separate page: the attract battle
// keeps rendering on the canvas underneath, so the first thing a visitor sees
// is the game playing itself rather than a static menu.
import React from "react";

const overlay = {
  position: "absolute",
  inset: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "18px",
  // Only the buttons take the mouse; everything else lets it through to the
  // canvas so the battle behind is never obscured by an invisible sheet.
  pointerEvents: "none",
  // Just enough to lift the text off the grass without hiding the fight.
  background:
    "radial-gradient(ellipse at center, rgba(24,20,12,0.62) 0%, rgba(24,20,12,0.34) 60%, rgba(24,20,12,0.18) 100%)",
};

const title = {
  margin: 0,
  fontSize: "62px",
  letterSpacing: "5px",
  color: "#f3e6c8",
  textShadow: "0 3px 0 #4a3418, 0 6px 18px rgba(0,0,0,0.75)",
  fontFamily: "Georgia, 'Times New Roman', serif",
};

const tagline = {
  margin: "0 0 22px",
  color: "#e0cfa4",
  fontSize: "17px",
  letterSpacing: "2px",
  textShadow: "0 2px 6px rgba(0,0,0,0.8)",
};

const button = (primary) => ({
  pointerEvents: "auto",
  cursor: "pointer",
  width: "330px",
  padding: primary ? "20px 0" : "14px 0",
  fontSize: primary ? "26px" : "18px",
  fontWeight: 700,
  letterSpacing: "2px",
  fontFamily: "Georgia, 'Times New Roman', serif",
  color: primary ? "#2a1c08" : "#f0e2c0",
  background: primary
    ? "linear-gradient(#f5d98a, #d8a441 55%, #b9822b)"
    : "linear-gradient(#6c5836, #4a3b22)",
  border: primary ? "3px solid #7a5518" : "3px solid #33280f",
  borderRadius: "8px",
  boxShadow: "0 5px 0 rgba(0,0,0,0.45), 0 10px 26px rgba(0,0,0,0.5)",
});

// One of the few things on this screen that takes the mouse, so it needs
// pointerEvents of its own like the buttons do.
const nameField = {
  pointerEvents: "auto",
  width: "330px",
  padding: "12px 14px",
  fontSize: "18px",
  letterSpacing: "1px",
  fontFamily: "Georgia, 'Times New Roman', serif",
  textAlign: "center",
  color: "#f3e6c8",
  background: "rgba(24,20,12,0.72)",
  border: "3px solid #6c5836",
  borderRadius: "8px",
  outline: "none",
};

const HomeScreen = ({ onPlayOnline, onVsBots, name, onNameChange }) => (
  <div style={overlay}>
    <h1 style={title}>BOMBASTIC</h1>
    <p style={tagline}>BOMBARD CANNON SKIRMISH</p>
    <input
      style={nameField}
      value={name}
      maxLength={24}
      aria-label="Your name"
      // Comes pre-filled with a name they can simply accept: picking one
      // should be optional, not a gate in front of the game.
      onChange={(event) => onNameChange(event.target.value)}
      // Enter is the obvious way out of a text box, and the primary button is
      // where it should land.
      onKeyDown={(event) => event.key === "Enter" && onPlayOnline()}
    />
    <button style={button(true)} onClick={onPlayOnline}>
      Play Online
    </button>
    <button style={button(false)} onClick={onVsBots}>
      Vs Bots
    </button>
  </div>
);

export default HomeScreen;
